module.exports = __webpack_public_path__ + "img/store-apple-black.b2ba316.png";